import PropTypes from 'prop-types';
import React from 'react';

import { VideoStyled } from './TrlVideo.styles';

export const TrlVideo = ({ videoUrl }) => {
  const isVideoFromYoutube = videoUrl?.includes('youtube');
  const videoRegexData = videoUrl?.match(/[?&]v=([^&]+)/);
  const youtubeVideoId = videoRegexData ? videoRegexData[1] : null;

  if (isVideoFromYoutube && youtubeVideoId)
    return (
      <VideoStyled
        component="iframe"
        src={`https://www.youtube.com/embed/${youtubeVideoId}`}
      />
    );

  return <VideoStyled component="video" src={videoUrl} controls />;
};

TrlVideo.propTypes = {
  videoUrl: PropTypes.string.isRequired,
};
